<div class="container text-center">
    <div class="row">
        <div class="col align-self-center">
            <div class="page-title">
                <h2>{{ titleTranslateKey | translate }}</h2>
            </div>
        </div>
    </div>
</div>

<div class="content" style="padding-bottom: 60px;">
    <div class="container-fluid">
        <div class="row">
            <div class="col align-self-center">
                <div class="mx-auto col-md-6 col-xs-12">
                    <div class="card" style="margin-bottom: 40px;">
                        <div class="card-body" style="padding-bottom: 30px;">
                            <div *ngIf="!loading; else loadingDiv">
                                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

                                    <!-- User Type -->
                                    <div class="col-md-12 mb-3">
                                        <label>{{'signup.account_type' | translate}}</label> <span class="required">*</span>
                                        <select formControlName="userType" class="form-select"
                                                [ngClass]="{ 'is-invalid': f.userType.touched && f.userType.errors }">
                                            <option value="buyer">{{'signup.buyer' | translate}}</option>
                                            <option value="seller">{{'signup.seller' | translate}}</option>
                                            <option value="carrier">{{'signup.carrier' | translate}}</option>
                                        </select>
                                        <div *ngIf="f.userType.touched && f.userType.errors" class="invalid-feedback">
                                            {{'signup.account_type_required' | translate}}
                                        </div>
                                    </div>

                                    <!-- First Name -->
                                    <div class="col-md-12 mb-3">
                                        <label>{{'common.firstName' | translate}}</label> <span class="required">*</span>
                                        <input type="text" formControlName="firstName" class="form-control"
                                               [ngClass]="{ 'is-invalid': f.firstName.touched && f.firstName.errors }"/>
                                        <div *ngIf="f.firstName.touched && f.firstName.errors" class="invalid-feedback">
                                            <div *ngIf="f.firstName.errors.required">{{'user_profile.firstName_required' | translate}}</div>
                                        </div>
                                    </div>

                                    <!-- Last Name -->
                                    <div class="col-md-12 mb-3">
                                        <label>{{'common.lastName' | translate}}</label> <span class="required">*</span>
                                        <input type="text" formControlName="lastName" class="form-control"
                                               [ngClass]="{ 'is-invalid': f.lastName.touched && f.lastName.errors }"/>
                                        <div *ngIf="f.lastName.touched && f.lastName.errors" class="invalid-feedback">
                                            <div *ngIf="f.lastName.errors.required">{{'user_profile.lastName_required' | translate}}</div>
                                        </div>
                                    </div>

                                    <!-- Email -->
                                    <div class="col-md-12 mb-3">
                                        <label>{{'common.email' | translate}}</label> <span class="required">*</span>
                                        <input type="email" formControlName="email" class="form-control"
                                               [attr.autocomplete]="'off'"
                                               [ngClass]="{ 'is-invalid': f.email.touched && f.email.errors }"/>
                                        <div *ngIf="f.email.errors && f.email.touched" class="invalid-feedback">
                                            <div *ngIf="f.email.errors.required">{{'signup.email_required' | translate}}</div>
                                            <div *ngIf="f.email.errors.email">{{'signup.invalid_email' | translate}}</div>
                                        </div>
                                    </div>

                                    <!-- Country + Phone side by side -->
                                    <div class="col-md-12 mb-3">
                                        <div class="row g-2">
                                            <!-- Country with flag -->
                                            <div class="col-5">
                                                <label>{{'common.country' | translate}}</label> <span class="required">*</span>
                                                <mat-select formControlName="code" class="country-mat-select"
                                                            [ngClass]="{ 'is-invalid': f.code.touched && f.code.errors }"
                                                            (selectionChange)="onCountryChange($event)"
                                                            disableOptionCentering
                                                            panelClass="country-select-panel">
                                                    <mat-option *ngFor="let c of countries" [value]="c.id">
                                                        <img [src]="'https://flagcdn.com/16x12/' + c.iso?.toLowerCase() + '.png'"
                                                             [alt]="c.iso"
                                                             onerror="this.style.display='none'"
                                                             width="16" height="12"
                                                             style="margin-right: 8px; vertical-align: middle;"/>
                                                        <span style="font-weight: 600;">{{ c.nicename }}</span>
                                                    </mat-option>
                                                </mat-select>
                                                <div *ngIf="f.code.touched && f.code.errors" class="invalid-feedback d-block">
                                                    {{'common.select_country_from_list' | translate}}
                                                </div>
                                            </div>

                                            <!-- Phone -->
                                            <div class="col-7">
                                                <label>{{'signup.phone_number' | translate}}</label> <span class="required">*</span>
                                                <input type="text" formControlName="phone" class="form-control"
                                                       [ngClass]="{ 'is-invalid': f.phone.touched && f.phone.errors }"
                                                       [attr.autocomplete]="'off'"
                                                       [placeholder]="'common.phone_with_code' | translate"/>
                                                <div *ngIf="f.phone.touched && f.phone.errors" class="invalid-feedback">
                                                    <div *ngIf="f.phone.errors.required">{{'login.phone_number_required' | translate}}</div>
                                                    <div *ngIf="f.phone.errors.phoneMustValid">{{'signup.phone_not_valid' | translate}}</div>
                                                    <div *ngIf="f.phone.errors.cameroonPhoneMustBe9Digits">{{'signup.cameroon_phone_9_digits' | translate}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Password -->
                                    <div class="col-md-12 mb-3">
                                        <label>{{'login.password' | translate}}</label> <span class="required">*</span>
                                        <input type="password" formControlName="password" class="form-control"
                                               [ngClass]="{ 'is-invalid': f.password.touched && f.password.errors }"/>
                                        <div *ngIf="f.password.touched && f.password.errors" class="invalid-feedback">
                                            <div *ngIf="f.password.errors.required">{{'login.password_required' | translate}}</div>
                                            <div *ngIf="f.password.errors.minlength != null">{{'signup.invalid_password' | translate}}</div>
                                            <div *ngIf="f.password.errors.pattern !== null">{{'signup.invalid_password_pattern' | translate}}</div>
                                        </div>
                                    </div>

                                    <!-- Confirm Password -->
                                    <div class="col-md-12 mb-3">
                                        <label>{{'signup.confirm_password' | translate}}</label> <span class="required">*</span>
                                        <input type="password" formControlName="confirmPassword" class="form-control"
                                               [ngClass]="{ 'is-invalid': f.confirmPassword.touched && f.confirmPassword.errors }"/>
                                        <div *ngIf="f.confirmPassword.touched && f.confirmPassword.errors" class="invalid-feedback">
                                            <div *ngIf="f.confirmPassword.errors.mustMatch">{{'signup.password_mismatch' | translate}}</div>
                                        </div>
                                    </div>

                                    <!-- Actions -->
                                    <div class="col-md-12 mb-3">
                                        <button type="submit" [disabled]="registerForm.invalid || submitted"
                                                class="btn btn-success" name="send" id="send2">
                                            <span>{{ (submitted ? 'common.pending' : 'common.register') | translate }}</span>
                                        </button>
                                        &nbsp;&nbsp;
                                        <a [routerLink]="['/signin']" class="back_link">
                                            {{'common.back_to_login' | translate}}
                                        </a>
                                    </div>

                                    <p id="success-messages" style="margin-top: 10px; color: #0c812c;"></p>
                                    <p id="error-messages" class="required" style="margin-top: 10px;"></p>
                                </form>

                            </div>

                            <ng-template #loadingDiv>
                                <div class="loader-box">
                                    <div class="lds-dual-ring"></div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>